import React from 'react';
import { Sprite } from '@agissc/ktag-map';
import './noIdentify.scss';
import { useTranslation } from 'react-i18next';

const NoIdentify = () => {
  const { t } = useTranslation('agisviewer');
  return (
    <div className="noIdentify">
      <p>
        <Sprite id="i-circle" additionalClassNames="identify_message_icon" />
        {t('identify_noIdentify_message')}
      </p>
    </div>
  );
};

export default NoIdentify;
